module.exports = require("net");


/*****************
 ** WEBPACK FOOTER
 ** external "net"
 ** module id = 335
 ** module chunks = 0
 **/